// IMPORTANT NOTE:
// These files are also present in FEA until blu_constants is rolled out
// if you change anything here, you need to change it there as well.

import FullLicense from "./full";
import SelfServiceLicense from "./self_service";
import m365 from "./m365";
import cloud from "./cloud";
import siem_pro from "./siem_pro";
import siem_endpoint from "./siem_endpoint";
import xdr from "./xdr";

export default {
  FREE: SelfServiceLicense,
  M365: m365,
  CLOUD: cloud,
  ADVANCED: FullLicense,
  SIEM_PRO: siem_pro,
  SIEM_ENDPOINT: siem_endpoint,
  XDR: xdr,
};
